import React, { FC } from "react";
import Highcharts from "highcharts";
import HighchartsTreemap from "highcharts/modules/treemap";
import HighchartsReact from "highcharts-react-official";
import { Spin } from "antd";
import useHttpGet from "../../hooks/useHttpGet";
import { APIRoutes } from "../../http";
import { IResultResponse } from "../../models/response/result.model";
import { IFactorValue } from "../../models/factorValue.model";
import CommonService from "../../services/common.service";
import HighChartsService from "../../services/highcharts.service";

HighchartsTreemap(Highcharts);

const FearAndGreed: FC = () => {
  const { fetchedData, loading } = useHttpGet<IResultResponse<IFactorValue>>(
    APIRoutes.FEAR_AND_GREED,
    {
      defaultValue: { result: {} as IFactorValue },
    }
  );

  const getOptions = (fearAndGreedIndex: number) => {
    return {
      ...HighChartsService.baseSettings({
        chart: {
          type: 'gauge',
          plotBackgroundColor: null,
          plotBorderWidth: 0,
          plotShadow: false,
          height: '430px',
        },

        xAxis: null,
        legend: null,
        // the value axis
        yAxis: {
          min: 0,
          max: 100,
          tickPosition: 'inside',
          tickColor: '#FFFFFF',
          tickLength: 20,
          tickWidth: 2,
          minorTickInterval: null,
          labels: {
            distance: 20,
            style: {
              fontSize: '14px'
            }
          },
          plotBands: [{
            from: 0,
            to: 33,
            color: '#DF5353', // red
            thickness: 20
          }, {
            from: 34,
            to: 66,
            color: '#DDDF0D', // yellow
            thickness: 20
          }, {
            from: 67,
            to: 100,
            color: '#55BF3B', // green
            thickness: 20
          }]
        },

        series: [{
          name: 'Fear & Greed',
          data: [fearAndGreedIndex],
          dataLabels: {
            format: '{y}',
            borderWidth: 0,
            color: '#333333',
            style: {
              fontSize: '16px'
            }
          },
          dial: {
            radius: '80%',
            backgroundColor: 'gray',
            baseWidth: 12,
            baseLength: '0%',
            rearLength: '0%'
          },
          pivot: {
            backgroundColor: 'gray',
            radius: 6
          }
        }]
      }),
      pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '70%'],
        size: '100%'
      },
    };
  };

  return (
    <Spin spinning={loading}>
      <HighchartsReact
        highcharts={Highcharts}
        options={getOptions(Math.round(fetchedData?.result?.value))}
      />
    </Spin>
  );
};

export default FearAndGreed;